import { Paper, Typography, colorsPalette, styled } from '@lingoda/ui';

interface ActivityBlockProps {
    value: number;
    label: string;
}

export const ParticipantActivityItem = ({ value, label }: ActivityBlockProps) => {
    return (
        <StyledPaper variant="outlined">
            <Typography variant="h2">{value}</Typography>
            <Typography
                variant="subtitle2"
                htmlColor={colorsPalette.blackAlpha[60]}
                marginLeft={0.5}
                marginBottom={0.25}
            >
                {label}
            </Typography>
        </StyledPaper>
    );
};

const StyledPaper = styled(Paper)(({ theme }) => ({
    flex: '1 1 auto',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    background: 'transparent',
    padding: theme.spacing(2),
}));
